import styled from 'styled-components';

export interface ICardProgressBarProps {
    progress?: number;
}

export function CardProgressBar(props: Readonly<ICardProgressBarProps>) {
    return (
        <StyledProgressBar>
            <StyledProgress progress={props.progress} />
        </StyledProgressBar>
    );
}
const StyledProgressBar = styled.div<ICardProgressBarProps>`
    background-color: #ffc5fb;
    height: 5px;
    position: relative;
    z-index: 1020;
`;

const StyledProgress = styled.div<ICardProgressBarProps>`
    width: ${(props) => `${props.progress}%`};
    top: 0;
    left: 0;
    height: 5px;
    background-color: #cf07be;
    transition: width 0.5s;
`;
